// extracted by mini-css-extract-plugin
module.exports = {"container":"container--29eBK","pic":"pic--2ik0C","title":"title--1Mx6N","loading":"loading--1ZK4p","success":"success--3oOkA","succes-info":"succes-info--2wMCL"};